import { useEffect, useRef, useCallback } from 'react';
import { useBlocker } from 'react-router-dom';

const useUnsavedChanges = (isDirty) => {
  const isSafeToNavigate = useRef(false);

  // Block navigation if there are unsaved changes
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) =>
        !isSafeToNavigate.current && isDirty && currentLocation.pathname !== nextLocation.pathname,
      [isDirty]
    )
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const proceed = window.confirm(
        'You have unsaved changes. Are you sure you want to leave?'
      );
      if (proceed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  // Handle browser-level events (tab close, reload)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty && !isSafeToNavigate.current) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);

  const setSafeToNavigate = useCallback(() => {
    isSafeToNavigate.current = true;
  }, []);

  return setSafeToNavigate;
};

export default useUnsavedChanges;